import Icon from '@ant-design/icons';
import React from 'react';

const SelectSvg = () => (
  <svg width='1em' height='1em' fill='currentColor' viewBox='0 0 512 512'>
    <polygon points='429.742,319.31 82.489,0 82.258,471.744 187.633,370.918 249.523,512 346.083,469.642 284.193,328.56 		' />
  </svg>
);

const MoveSvg = () => (
  <svg
    width='1em'
    height='1em'
    fill='currentColor'
    viewBox='0 0 24 24'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <polyline points='5 9 2 12 5 15'></polyline>
    <polyline points='9 5 12 2 15 5'></polyline>
    <polyline points='15 19 12 22 9 19'></polyline>
    <polyline points='19 9 22 12 19 15'></polyline>
    <line x1='2' y1='12' x2='22' y2='12'></line>
    <line x1='12' y1='2' x2='12' y2='22'></line>
  </svg>
);

const ColumnSvg = () => (
  <svg width='1em' height='1em' fill='currentColor' viewBox='0 0 512 512'>
    <path d='m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 341.332031c-47.0625 0-85.332031-38.269531-85.332031-85.332031s38.269531-85.332031 85.332031-85.332031 85.332031 38.269531 85.332031 85.332031-38.269531 85.332031-85.332031 85.332031zm0 0' />
  </svg>
);

const RectSvg = () => (
  <svg width='1em' height='1em' fill='currentColor' viewBox='0 0 512 512'>
    <path
      d='M466.052,374.155V45.948H137.847V0H0v137.847h45.948v328.205h328.205V512H512V374.155H466.052z M91.897,91.897H45.948
			V45.948h45.948V91.897z M420.103,374.153h-45.948v0.001v45.948H91.898V137.847h45.948v-45.95h282.256V374.153z M466.052,466.052
			h-45.948v-45.948h45.948V466.052z'
    />
  </svg>
);

const PolygonSvg = () => (
  <svg width='1em' height='1em' fill='currentColor' viewBox='0 0 512 512'>
    <path d='m497.027344 209.589844h-9.8125l-69.691406-119.765625h9.640624c8.269532 0 14.972657-6.703125 14.972657-14.96875v-59.882813c0-8.269531-6.703125-14.972656-14.972657-14.972656h-59.882812c-8.265625 0-14.96875 6.703125-14.96875 14.972656v16.253906h-192.625v-16.253906c0-8.269531-6.703125-14.972656-14.96875-14.972656h-59.882812c-8.269532 0-14.972657 6.703125-14.972657 14.972656v59.882813c0 8.265625 6.703125 14.96875 14.972657 14.96875h7.925781l-69.148438 119.765625h-8.640625c-8.269531 0-14.972656 6.703125-14.972656 14.972656v59.882812c0 8.265626 6.703125 14.96875 14.972656 14.96875h8.640625l70.300781 121.761719h-9.078124c-8.269532 0-14.972657 6.703125-14.972657 14.972657v59.882812c0 8.269531 6.703125 14.96875 14.972657 14.96875h59.882812c8.265625 0 14.96875-6.699219 14.96875-14.96875v-18.253906h192.625v18.253906c0 8.269531 6.703125 14.96875 14.96875 14.96875h59.882812c8.269532 0 14.972657-6.699219 14.972657-14.96875v-59.882812c0-8.269532-6.703125-14.972657-14.972657-14.972657h-10.074218l70.296875-121.761719h9.640625c8.269531 0 14.972656-6.703124 14.972656-14.96875v-59.882812c0-8.269531-6.703125-14.972656-14.972656-14.972656zm-14.96875 29.941406v29.941406h-29.941406v-29.941406zm-99.804688-209.589844h29.941406v29.941406h-29.941406zm-282.449218 0h29.941406v29.941406h-29.941406zm-69.863282 239.53125v-29.941406h29.941406v29.941406zm99.804688 211.585938h-29.941406v-29.941406h29.941406zm282.449218 0h-29.941406v-29.941406h29.941406zm-29.679687-59.882813h-15.234375c-8.265625 0-14.96875 6.703125-14.96875 14.972657v11.6875h-192.625v-11.6875c0-8.269532-6.703125-14.972657-14.96875-14.972657h-16.230469l-70.300781-121.761719h16.667969c8.265625 0 14.96875-6.703124 14.96875-14.96875v-59.882812c0-8.269531-6.703125-14.972656-14.96875-14.972656h-16.667969l69.148438-119.765625h17.382812c8.265625 0 14.96875-6.703125 14.96875-14.96875v-13.6875h192.625v13.6875c0 8.265625 6.703125 14.96875 14.96875 14.96875h15.597656l69.695313 119.765625h-15.429688c-8.265625 0-14.96875 6.703125-14.96875 14.972656v59.882812c0 8.265626 6.703125 14.96875 14.96875 14.96875h15.671875zm0 0' />
  </svg>
);

const LineSvg = () => (
  <svg width='1em' height='1em' fill='currentColor' viewBox='0 0 512 512'>
    <rect x='-86.01' y='235.971' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -106.0382 255.9989)' width='684.019' height='40.056' />
  </svg>
);

export const SelectIcon = (props: any) => <Icon component={SelectSvg} {...props} />;
export const MoveIcon = (props: any) => <Icon component={MoveSvg} {...props} />;
export const ColumnIcon = (props: any) => <Icon component={ColumnSvg} {...props} />;
export const RectIcon = (props: any) => <Icon component={RectSvg} {...props} />;
export const PolygonIcon = (props: any) => <Icon component={PolygonSvg} {...props} />;
export const LineIcon = (props: any) => <Icon component={LineSvg} {...props} />;
